<template>
  <div class="gp-header">
    <div class="left" @click="goToWeb('https://www.gpowersoft.com/')">
      <img src="@/assets/logo.png" height="60" />
      <!-- <div class="text">智能问答平台</div> -->
    </div>
    <!-- <div class="right" @click="resetData">
      <svg-icon icon="clean" title="清除对话记录"/>
    </div> -->
  </div>
</template>

<script>
export default {
  methods: {
    goToWeb(url) {
      window.open(url)
    },
    resetData() {
      this.$confirm({
        title: '提示',
        content: '是否确认清空对话记录？',
        okText: '是',
        cancelText: '否',
        onOk() {
          sessionStorage.removeItem(`${process.env.VUE_APP_NAME}:conversation_id`)
          location.reload()
        },
        onCancel() {},
      });
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";

.gp-header {
  cursor: pointer;
  // width: 100%;
  // height: 100px;
  // box-sizing: border-box;
  // background: @qa-header-bg-color;
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  left: 55px;
  top: 45px;
  z-index: 999;
  // padding: 20px 50px;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // .left{
  //   display: flex;
  //   align-items: center;
  // }
  // .right{
  //   cursor: pointer;
  // }
  // .divider.vertical {
  //   width: 2px;
  //   height: 55px;
  //   background: #dfdfdf;
  //   margin: 20px 8px 8px 8px;
  // }
  // .text {
  //   font-size: 32px;
  //   margin-left: 8px;
  //   color: @qa-header-text-color;
  //   font-family: monospace;
  // }
}
</style>
